import React, { useState, useEffect } from "react";
import { login, removeCheckoutClientInfo } from "../../services/authService";
import Alert from "../HtmlElements/Alert";
import { useUser } from "../../context/UserContext";
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../services/commonService";
import { useLocation, useParams } from "react-router-dom";
import "../Login/Login.css"; // Reuse existing styles

const AdminLogin = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const { fetchUserDetails } = useUser(); // Assuming fetchUserDetails is exposed or imported directly? 
    // Wait, fetchUserDetails is imported from authService in Login.js. 
    // But Login.js also uses useUser() for setUser, etc.

    // Actually Login.js imports fetchUserDetails from authService, NOT from useUser context.
    // Although useUser context calls it internally.
    // Let's stick to how Login.js does it.

    var currentUrl = useLocation().pathname;
    var pageParsedData = getUrlDetailsObj(useLocation, useParams);

    const toggleShowPassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email || !password) {
            setError("Please enter both email and password.");
            return;
        }

        setLoading(true);

        try {
            const isLogin = await login(email, password);
            if (isLogin === true) {
                // Log activity
                const userStat = getUserStatsObject(
                    "Admin Login",
                    "login",
                    "Admin Login successful",
                    currentUrl
                );
                userStat.url_details = pageParsedData;
                recordActivity(userStat);

                removeCheckoutClientInfo();

                // Redirect to /admin (which will now show the dashboard because of AdminRoot wrapper)
                window.location.replace("/admin");

            } else {
                setError("Incorrect username or password. Please try again.");
            }
        } catch (err) {
            setError(err.message || "Login Failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="main-container">
            <div className="main-content">
                <div className="login_page_wrapper">
                    <div className="sub_wrapper" style={{ justifyContent: 'center' }}>
                        {/* Simplified layout for Admin */}
                        <div className="login_right_block " style={{ margin: "0 auto", float: 'none' }}>
                            <div className="login_block">
                                <h5 className="login_head">Super Admin Login</h5>
                                <p className="login_para">
                                    Sign in to manage the platform
                                </p>
                                <div className="main_form_login">
                                    {error && <Alert type="danger" message={error} />}
                                    <form onSubmit={handleSubmit}>
                                        <div className="mb-3">
                                            <label htmlFor="email" className="form-label custom_label">Email</label>
                                            <span className="block input-icon input-icon-right">
                                                <input
                                                    type="email"
                                                    className="form-control custom_form_control"
                                                    id="email"
                                                    placeholder="Admin Email"
                                                    autoComplete="off"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                />
                                            </span>
                                        </div>

                                        <div className="mb-3">
                                            <label htmlFor="password" className="form-label custom_label">Password</label>
                                            <span className="block input-icon input-icon-right">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control custom_form_control"
                                                    id="password"
                                                    placeholder="Password"
                                                    autoComplete="off"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />
                                                <div className="input-group-append" style={{ position: "absolute", right: "10px", top: "7px", zIndex: "5" }}>
                                                    <span onClick={toggleShowPassword} style={{ cursor: "pointer" }}>
                                                        <i className={`fa fa-eye${showPassword ? "" : "-slash"}`} aria-hidden="true"></i>
                                                    </span>
                                                </div>
                                            </span>
                                        </div>

                                        <div className="space-6"></div>
                                        <button disabled={loading} type="submit" className="btn btn-primary custom_log_btn w-100">
                                            {loading ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-key"></i>} Login
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
